import React from 'react';
import { Avatar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { AvatarPlaceholder } from '@uplift/icons';

export type ProviderAvatarProps = {
  src: string;
  size?: number;
};


export const ProviderAvatar: React.FC<ProviderAvatarProps> = ({ src, size }) => {
  const { classes } = useStyles({ size });

  if (!src) {
    return <AvatarPlaceholder width={`${size}px`} height={`${size}px`} />;
  }

  return (
    <Avatar
      alt="account img"
      variant="square"
      src={src}
      className={classes.accountImage}
    />
  );
};


const useStyles = makeStyles<Partial<ProviderAvatarProps>>()((theme, { size }) => ({
  accountImage: {
    width: size ? `${size}px` : '88px',
    height: size ? `${size}px` : '88px',
  },
}));
